import React from "react";
import { BsGithub } from "react-icons/bs";

const ProjectsCard = ({ title, des, src, githubLink }) => {
    return (
        <div className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:to-gray-900 transition-colors duration-1000">

            {/* Image */}
            <div className="w-full h-[80%] overflow-hidden rounded-lg">
                <img
                    className="w-full h-60 object-cover group-hover:scale-110 duration-300 cursor-pointer"
                    src={src}
                    alt={title}
                />
            </div>

            {/* Content */}
            <div className="w-full mt-5 flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <h3 className="text-base uppercase text-designColor font-normal">
                        {title}
                    </h3>

                    {/* GitHub icon */}
                    {githubLink && (
                        <a
                            href={githubLink}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="GitHub repository"
                            className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300"
                        >
                            <BsGithub />
                        </a>
                    )}
                </div>

                <p className="text-sm tracking-wide text-gray-400">
                    {des}
                </p>
            </div>
        </div>
    );
};

export default ProjectsCard;
